var Log = require('../log')
var Adapter = require('../adapter/adapter')
var NpawVideo = require('../video/video')

// This file is designed to add extra functionalities to Plugin class

/** @lends npaw.Plugin.prototype */
var PluginAdapterMixin = {
  /**
   *
   * @param {object|string} player
   * @param {string} adapterJsonCode
   * @param {object} options
   * @param {object} videoKey
   */
  registerAdapter: function (player, adapterJsonCode, options, videoKey) {
    if (!adapterJsonCode) {
      Log.error('Register Adapter needs a json code to initialize')
      return
    }
    options = options || {}
    videoKey = videoKey || 'default'
    if (!this.videos.existsVideo(videoKey)) {
      // First, create new empty video object
      var videoObj = new NpawVideo(videoKey, this, this.options, null, null)
      options = options || {}
      videoObj.mergeOptions(options)
      this.videos.setVideo(videoObj)
      // Then, create adapter, and set adapter
      var adapter = new Adapter(videoKey, videoObj, this, this.adapterTemplates, player, adapterJsonCode)
      this.setAdapter(adapter, videoKey)
    } else {
      options = options || {}
      this.videos.getVideo(videoKey).mergeOptions(options)
      this.setAdapter(new Adapter(videoKey, this.videos.getVideo(videoKey), this, this.adapterTemplates, player, adapterJsonCode), videoKey)
    }
  },

  /**
   * Sets an adapter for video content.
   *
   * @param {Adapter} adapter
   * @param {string} videoKey
   *
   * @memberof npaw.Plugin.prototype
   */
  setAdapter: function (adapter, videoKey) {
    videoKey = videoKey || 'default'
    if (this.browserLoadTimes) this.browserLoadTimes.setPlayerSetupTime()
    if (adapter.isSetAdapter()) {
      Log.warn('Adapters can only be added to a single plugin')
    } else {
      this.removeAdapter(videoKey)
      this.videos.setAdapter(adapter, videoKey)
    }
  },

  /**
   * Returns current adapter or null.
   *
   * @param {string} videoKey
   * @returns {Adapter}
   *
   * @memberof npaw.Plugin.prototype
   */
  getAdapter: function (videoKey) {
    videoKey = videoKey || 'default'
    return this.videos.getAdapter(videoKey)
  },

  /**
   * Removes the current adapter. Fires stop if needed. Calls adapter.dispose().
   *
   * @param videoKey
   * @memberof npaw.Plugin.prototype
   * */
  removeAdapter: function (videoKey) {
    videoKey = videoKey || 'default'
    this.videos.removeAdapter(this.contentAdapterListeners, videoKey)
  }
}

module.exports = PluginAdapterMixin
